import { Injectable } from "@angular/core";
import { environment, environmentPingId, pingIdToken } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APICustomScheduleService {

  ApiURL: string = "";
  ApiURLDxp: string = '';
  constructor(private http: HttpClient, private helperService: HelperService) {
    this.ApiURL = environment.CustomScheduleUrl + 'CustomSchedule/';
    this.ApiURLDxp = environmentPingId.PingIdvehicleDataUrl + 'custom-schedule/info';
  }

    /**
     * Based on roles
     * @param roleId   mandatory but based on the id
     * @param firstId  brand or advisor
     * @param secondId firstid = brand ? city : typeOfService 
     * if there is a third this is contact center
     * @param thirdId  type of service Id
     * @param fourthId 
     * @returns a new array of 
     */

    public getScheduleDropDownLists(roleId:number,firstId: number, secondId?: number, thirdId?: number, fourthId?: number, fifthId?: number): Observable<any> {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.helperService.TokenBooking}`,
        'x-apikey': pingIdToken.clientId,
      })
      const requestOptions = {
          headers: headers,
      };
        const url = this.ApiURLDxp
        const body: any = {}
          body.FilterType =  "Filter"
          roleId ? body.RoleId = Number(roleId) : ''
          firstId ? body.Id1 = Number(firstId) : ''
          secondId ? body.Id2 =  Number(secondId) : ''
          thirdId ? body.Id3 =  Number(thirdId) : ''
          fourthId ? body.Id4 =  Number(fourthId) : ''
          fifthId ? body.Id5 =  Number(fifthId) : ''
          return this.http.post(url, body, requestOptions);
  }

  public getWebviewHoursWorkshopDropDownLists(date,hour, cityId,serviceId,brandId ): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
    };
    const url =`${this.ApiURL}FilterByWorkshop/${date}/${hour}/${cityId}/${serviceId}/${brandId}` ; 
    
    return this.http.get(url,requestOptions);
}
  public getFilteredData(roleId: number, firstId: number, secondId?: number, thirdId?: number, fourthId?: number, fifthId?: number, advisorId?: number): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
    };

      const url = this.ApiURLDxp
        const body: any = {}
          body.FilterType =  "Data"
          roleId ? body.RoleId = Number(roleId) : ''
          firstId ? body.Id1 = Number(firstId) : ''
          secondId ? body.Id2 =  Number(secondId) : ''
          thirdId ? body.Id3 =  Number(thirdId) : ''
          fourthId ? body.Id4 =  Number(fourthId) : ''
          fifthId ? body.Id5 =  Number(fifthId) : ''
          advisorId ? body.Id5 =  Number(advisorId) : ''
          return this.http.post(url, body, requestOptions);
}

public getScheduleDropDownListsWebviewDerco(filterType:string,firstId: number, secondId?: number,thirdId?: number, fourthId?: number, fifthId?: number): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${this.helperService.TokenBooking}`,
    'x-apikey': pingIdToken.clientId,
  });
  const requestOptions = {
    headers: headers,
  };
  const body: any = {
    Id1: firstId,
    Id2: secondId,
    Id3: thirdId,
    Id4: fourthId,
    Id5: fifthId,
    FilterType: filterType
  }
  const url = this.ApiURLDxp
  return this.http.post(url, body, requestOptions);
  
} 

  public getScheduleDropDownListsWebview(filterType: string,firstId: any, secondId?: number, thirdId?: number, fourthId?: number, fifthId?: number): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.helperService.TokenBooking}`,
      'x-apikey': pingIdToken.clientId,
    })
    const requestOptions = {
      headers: headers,
    };

    const url = `${this.ApiURLDxp}`
    const body: any = {}
    firstId ? body.Id1 = Number(firstId) : ''
    secondId ? body.Id2 =  Number(secondId) : ''
    thirdId ? body.Id3 =  Number(thirdId) : ''
    fourthId ? body.Id4 =  Number(fourthId) : ''
    fifthId ? body.Id5 =  Number(fifthId) : ''
    filterType ? body.FilterType =  String(filterType) : 'Country'
    return this.http.post(url, body, requestOptions);
  }
  public getByPlateIdentification(SiteUse: string, plate: string, pageNumber: string, pageSize: string, identification?: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.helperService.TokenBooking}`,
      'x-apikey': pingIdToken.clientId,
    })
    const requestOptions = {
      headers: headers,
    };

    const params = {
      "Flag": parseInt(SiteUse),
      "Identification": identification,
      "PageNumber": parseInt(pageNumber),
      "PageSize": parseInt(pageSize),
      "Plate": plate
    }
    const url = this.ApiURLDxp
    return this.http.post(url, params, requestOptions);
  }
  public getSchedulerByAdvisor(advisorId: number) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.helperService.TokenBooking}`,
      'x-apikey': pingIdToken.clientId,
    })
    const requestOptions = {
      headers: headers,
    };
    const body = { AdvisorId: advisorId };
    const url = `${this.ApiURLDxp}`;
    return this.http.post(url, body, requestOptions);
  }
    public get(id): Observable<any>{
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
      };
        return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
    }
}